import { useCallback } from 'react';
import {
  CandidateRegisteredExamListingResponse,
  ExamType,
} from '../../../api/candidate/exam/model';
import { GroupRegisteredExamModelResponse } from '../../../api-refactored/group-exam-registration/useGetCoordinatorGroupExamRegistrations';

export const useGetClosedExamTypes = (
  data?: GroupRegisteredExamModelResponse[] | CandidateRegisteredExamListingResponse[]
) => {
  const isWindowOpenedCallback = useCallback(() => {
    let opened = false;
    const closedExamType: ExamType[] = [];
    if (Array.isArray(data)) {
      data.forEach((item) => {
        if (
          !item.timeWindowOpen &&
          !item.supplementaryOpen &&
          !closedExamType.includes(item.examType)
        ) {
          closedExamType.push(item.examType);
        }
        opened = item.timeWindowOpen || item.supplementaryOpen;
      });
    }
    return {
      opened,
      closedExamType,
    };
  }, [data]);

  return { isWindowOpenedCallback };
};
